import { BaseAuthService } from './baseAuthService';
import { TOKEN_KEYS } from '../constants';
import { API_ENDPOINTS } from '@/shared/constants';

export const AdminAuthService = new BaseAuthService(
    TOKEN_KEYS.ADMIN,
    API_ENDPOINTS.EMPLOYEE,
);
